import { render, staticRenderFns } from "./HorizontalSawSettings.vue?vue&type=template&id=249a7810"
import script from "./HorizontalSawSettings.vue?vue&type=script&lang=js"
export * from "./HorizontalSawSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports